import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import CandidateStatusPill from './CandidateStatusPill';
import formatCandidateCode from '../../utils/formatCandidateCode';
import './CandidatesTable.css';

class CandidatesTable extends Component {
  headerCheckbox = null;

  componentDidMount() {
    this.syncIndeterminate();
  }

  componentDidUpdate() {
    this.syncIndeterminate();
  }

  // `indeterminate` is a DOM property, not an attribute.
  syncIndeterminate() {
    if (this.headerCheckbox) {
      this.headerCheckbox.indeterminate = this.props.selectionState === 'some';
    }
  }

  renderReason(candidate) {
    if (candidate.reason === 'already_in_destination') {
      return (
        <span className="candidate-reason">
          {I18n.t('campaigns.move.alreadyInDestination')}
        </span>
      );
    }
    if (candidate.reason === 'ie_disabled_in_destination') {
      return (
        <span className="candidate-reason">
          {I18n.t('campaigns.move.ieDisabledInDestination')}
        </span>
      );
    }
    return null;
  }

  render() {
    const {
      candidates,
      selection,
      selectionState,
      selectable,
      statusLabelKey,
      onToggle,
      onToggleAll,
    } = this.props;
    const hasMovable = candidates.some((candidate) => candidate.movable);

    return (
      <div className="candidates-table-wrapper">
        <table className="candidates-table">
          <thead>
            <tr>
              {selectable && (
                <th className="check-cell">
                  <input
                    type="checkbox"
                    ref={(node) => {
                      this.headerCheckbox = node;
                    }}
                    checked={selectionState === 'all'}
                    disabled={!hasMovable}
                    onChange={onToggleAll}
                  />
                </th>
              )}
              <th>{I18n.t('campaigns.move.email')}</th>
              <th className="status-cell">{I18n.t(statusLabelKey)}</th>
              <th className="code-cell">{I18n.t('campaigns.move.code')}</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map((candidate) => {
              const disabled = !candidate.movable;
              return (
                <tr
                  key={candidate.invitation_id}
                  className={disabled ? 'disabled' : ''}
                  title={
                    candidate.reason === 'playing'
                      ? I18n.t('campaigns.move.playing')
                      : undefined
                  }
                >
                  {selectable && (
                    <td className="check-cell">
                      <input
                        type="checkbox"
                        checked={selection.includes(candidate.invitation_id)}
                        disabled={disabled}
                        onChange={() => onToggle(candidate)}
                      />
                    </td>
                  )}
                  <td className="email-cell">
                    <div className="email-wrap">
                      <span className="candidate-email" title={candidate.email}>
                        {candidate.email}
                      </span>
                      {this.renderReason(candidate)}
                    </div>
                  </td>
                  <td>
                    <CandidateStatusPill state={candidate.state} />
                  </td>
                  <td className="code-cell">
                    {formatCandidateCode(candidate.code)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

CandidatesTable.defaultProps = {
  selection: [],
  selectionState: 'none',
  selectable: true,
  statusLabelKey: 'campaigns.move.status.label',
  onToggle: () => {},
  onToggleAll: () => {},
};
CandidatesTable.propTypes = {
  candidates: PropTypes.array.isRequired,
  selection: PropTypes.array,
  selectionState: PropTypes.oneOf(['none', 'some', 'all']),
  selectable: PropTypes.bool,
  statusLabelKey: PropTypes.string,
  onToggle: PropTypes.func,
  onToggleAll: PropTypes.func,
};

export default CandidatesTable;
